import styled from 'styled-components';

export const FoodItem = styled.div`
    position: absolute;
    background-color: var(--color-green);
    z-index: 1;
    border-radius: 50%;
`;
